import React, { useContext } from 'react';
import { Context as AuthContext } from '../../contexts/AuthContext';
import isAuthorized from '../../helpers/isAuthorized';

interface CanProps {
  moduleName: string;
  functionName: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const CanElse = ({ children }: { children: React.ReactNode }) => <>{children}</>;
CanElse.displayName = 'Can.Else';

const Can = ({ moduleName, functionName, children, fallback = null }: CanProps) => {
  const { user }: any = useContext(AuthContext);
  const allowed = isAuthorized({ moduleName, functionName }, user);

  const childrenArray = React.Children.toArray(children);
  const elseChild = childrenArray.find((child) => React.isValidElement(child) && child.type === CanElse) as
    | React.ReactElement
    | undefined;
  const mainChildren = childrenArray.filter((child) => !(React.isValidElement(child) && child.type === CanElse));

  if (allowed) {
    return <>{mainChildren}</>;
  }

  if (elseChild) {
    return <>{elseChild.props.children}</>;
  }

  return <>{fallback}</>;
};

Can.Else = CanElse;

export default Can;
